<template src="./template.html"></template>
<script>
export default {
  name: 'membership-perks',
  data() {
    return {}
  },
  methods: {},
  updated() {
    this.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipPerks/index.vue